export enum FormMode {
	None,
	Create,
	Update,
}
